import { render, staticRenderFns } from "./Attributes.page.vue?vue&type=template&id=73c3865e&"
import script from "./Attributes.page.vue?vue&type=script&lang=js&"
export * from "./Attributes.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports